import { render, staticRenderFns } from "./ServiceDetails.vue?vue&type=template&id=b4937d7e&"
import script from "./ServiceDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4937d7e')) {
      api.createRecord('b4937d7e', component.options)
    } else {
      api.reload('b4937d7e', component.options)
    }
    module.hot.accept("./ServiceDetails.vue?vue&type=template&id=b4937d7e&", function () {
      api.rerender('b4937d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/services/ServiceDetails.vue"
export default component.exports